export const ADMIN_BILLING_GET = 'ADMIN_BILLING_GET';
export const ADMIN_BILLING_GET_SUCCESS = 'ADMIN_BILLING_GET_SUCCESS';
export const ADMIN_BILLING_GET_FAIL = 'ADMIN_BILLING_GET_FAIL';

export const ADMIN_BILLING_CLEAR = 'ADMIN_BILLING_CLEAR';
